import "./Line.scss";
import LineDialog from "../../../Dialogs/LineDialog";
import { useState } from "react";
import Button from "../../../../../buttons/Button";
import { buildUrl } from "../../../../../utils/helper";
export default function Line({ props }) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      {
        isOpen &&
        <LineDialog setOpen={setIsOpen} isOpen={isOpen} setBuildArea={props.setBuildArea} editData={{ line: props.line, rowIndex: props.rowIndex }} />
      }
      <div
        ref={props.providedField.innerRef}
        {...props.providedField.draggableProps}
        {...props.providedField.dragHandleProps}
        className={`line-container editable`}
      >
        <div className="line-buttons">
          <span>Čiara</span>
          <div className="edit-buttons">
            <Button
              onClick={() => setIsOpen(true)}
              imageUrl={buildUrl("assets/icons/toolbar/edit.svg")}
              title="Nastavenia čiary"
              className={"line-edit"}
            />
            <Button
              onClick={() => props.deleteRow(props.rowIndex)}
              imageUrl={buildUrl("assets/icons/close.svg")}
              title="Vymazať čiaru"
              className={"line-delete"}
            />
          </div>
        </div>
        {(props.line === "solid")
          &&
          <div className="line line-solid">
          </div>
        }
        {(props.line === "dotted")
          &&
          <div className="line line-dotted">
          </div>
        }
        {(props.line === "dashed")
          &&
          <div className="line line-dashed">
          </div>
        }
        {(props.line === "double")
          &&
          <div className="line line-double">
          </div>
        }
        {(props.line === "empty")
          &&
          <div className="line">
          </div>
        }
      </div>
    </>
  );
}
